"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.JobCancellation = void 0;
const typeorm_1 = require("typeorm/browser");
const cancellation_reason_1 = require("./cancellation-reason");
const job_1 = require("./job");
const api_id_1 = require("../util/api-id");
const cancellation_reason_2 = require("./cancellation-reason");
const comment_1 = require("./comment");
let JobCancellation = class JobCancellation {
    updateId() {
        this.id = (0, api_id_1.makeApiId)();
    }
};
JobCancellation.NAME_PREFIX = 'JCAN';
JobCancellation.NAME_LENGTH = 8;
__decorate([
    (0, typeorm_1.BeforeInsert)(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], JobCancellation.prototype, "updateId", null);
__decorate([
    (0, typeorm_1.PrimaryColumn)('varchar', {
        nullable: false,
        length: 18,
        name: 'id',
    }),
    __metadata("design:type", String)
], JobCancellation.prototype, "id", void 0);
__decorate([
    (0, typeorm_1.Column)('varchar', {
        nullable: false,
        name: 'name',
        length: 80,
        default: () => "gid_generate_name('JCAN', 8)",
    }),
    __metadata("design:type", String)
], JobCancellation.prototype, "name", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'enum',
        enum: cancellation_reason_1.CancellationReasonCategoryEnum,
        name: 'cancellation_reason_category__c',
    }),
    __metadata("design:type", String)
], JobCancellation.prototype, "cancellationReasonCategory", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => cancellation_reason_2.CancellationReasonOpportunity, (cro) => cro.id),
    (0, typeorm_1.JoinColumn)({
        name: 'cancellation_reason_opportunity_id__c',
        referencedColumnName: 'id',
    }),
    __metadata("design:type", cancellation_reason_2.CancellationReasonOpportunity)
], JobCancellation.prototype, "cancellationReasonOpportunity", void 0);
__decorate([
    (0, typeorm_1.Column)({
        name: 'old_price_selling__c',
        type: 'double precision',
        nullable: true,
    }),
    __metadata("design:type", Number)
], JobCancellation.prototype, "oldPriceSelling", void 0);
__decorate([
    (0, typeorm_1.Column)({
        name: 'new_price_selling__c',
        type: 'double precision',
        nullable: true,
    }),
    __metadata("design:type", Number)
], JobCancellation.prototype, "newPriceSelling", void 0);
__decorate([
    (0, typeorm_1.Column)({
        name: 'old_price_purchasing__c',
        type: 'double precision',
        nullable: true,
    }),
    __metadata("design:type", Number)
], JobCancellation.prototype, "oldPricePurchasing", void 0);
__decorate([
    (0, typeorm_1.Column)({
        name: 'new_price_purchasing__c',
        type: 'double precision',
        nullable: true,
    }),
    __metadata("design:type", Number)
], JobCancellation.prototype, "newPricePurchasing", void 0);
__decorate([
    (0, typeorm_1.Column)({
        name: 'old_price_lists__c',
        type: 'double precision',
        nullable: true,
    }),
    __metadata("design:type", Number)
], JobCancellation.prototype, "oldPriceLists", void 0);
__decorate([
    (0, typeorm_1.Column)({
        name: 'new_price_lists__c',
        type: 'double precision',
        nullable: true,
    }),
    __metadata("design:type", Number)
], JobCancellation.prototype, "newPriceLists", void 0);
__decorate([
    (0, typeorm_1.CreateDateColumn)({
        name: 'createddate',
    }),
    __metadata("design:type", Date)
], JobCancellation.prototype, "createdAt", void 0);
__decorate([
    (0, typeorm_1.Index)('hc_idx_job_cancellations__c_lastmodifieddate'),
    (0, typeorm_1.UpdateDateColumn)({
        name: 'lastmodifieddate',
    }),
    __metadata("design:type", Date)
], JobCancellation.prototype, "updatedAt", void 0);
__decorate([
    (0, typeorm_1.Index)('hc_idx_job_cancellations__c_job__c'),
    (0, typeorm_1.ManyToOne)((type) => job_1.Job, (job) => job.cancellations),
    (0, typeorm_1.JoinColumn)({ name: 'job__c', referencedColumnName: 'id' }),
    __metadata("design:type", job_1.Job)
], JobCancellation.prototype, "job", void 0);
__decorate([
    (0, typeorm_1.OneToOne)((type) => comment_1.Comment, (comment) => comment.cancellation, {
        onDelete: 'SET NULL',
        onUpdate: 'CASCADE',
    }),
    (0, typeorm_1.JoinColumn)(),
    __metadata("design:type", comment_1.Comment)
], JobCancellation.prototype, "comment", void 0);
JobCancellation = __decorate([
    (0, typeorm_1.Entity)('job_cancellations__c', { schema: 'public', synchronize: true })
], JobCancellation);
exports.JobCancellation = JobCancellation;
//# sourceMappingURL=job-cancellation.js.map